import { combineReducers } from 'redux';
import { defaultPolicies } from './constants';

export const policyData = (state = defaultPolicies) => {
	return state;
};

export interface IPoliciesState {
	policyData: ReturnType<typeof policyData>;
}

const policies = combineReducers<IPoliciesState>({
	policyData
});

export default policies;
